document.addEventListener("DOMContentLoaded", function () {
  var pdpATC = document.querySelector(".product-form__submit.button");
  var inputField = document.querySelector(
    ".input_engraving .nameInput_engraving"
  );
  var skipBtn = document.querySelector(".skipEngraving_btn");
  var confirmBtn = document.querySelector(".submitEngraving_btn");
  var inputHidden_note = document.querySelector(".text-area.field__input");
  var labelSwatchId = document.querySelectorAll(
    "variant-radios .product-form__input.Color input"
  );
  let personalisedText;
  pdpATC.type = "submit";

  const popUp = (action) => {
    document
      .querySelectorAll(".overlayPersonalize, .engraving_main")
      .forEach((ele) => {
        ele.classList[action]("hidden");
      });
  };

  document
    .querySelectorAll(".personalize_Engraving")
    .forEach((engraveButton) => {
      engraveButton.addEventListener("click", function () {
        popUp("remove");
      });
    });

  // document.querySelector('.closeEngraving').addEventListener('click', () => {
  //   popUp('add');
  //   document.querySelector('.errorOutOfStock').classList.add('hidden');
  //   inputField.value = '';
  //   skipBtn.classList.remove('hidden');
  //   confirmBtn.classList.add('hidden');
  // });

  var renderSwatch_color = document
    .querySelector(".product_engraving img")
    .getAttribute("value");
  window.renderSwatch_color = renderSwatch_color;

  inputField.addEventListener("input", () => {
    inputField.value = inputField.value.replace(/^ |[^A-Za-z0-9 ]/g, "");
    document.querySelector(".name__over_img").innerText = inputField.value;
    if (inputField.value.length > 0) {
      skipBtn.classList.add("hidden");
      confirmBtn.classList.remove("hidden");
    } else {
      skipBtn.classList.remove("hidden");
      confirmBtn.classList.add("hidden");
    }
  });

  inputField.addEventListener("keydown", () => {
    inputField.setAttribute("maxlength", "12");
  });

  confirmBtn.addEventListener("click", () => {
    personalisedText = inputField.value.trim();

    if (personalisedText === "") {
      location.reload();
      return;
    }

    let variantId = null;

    labelSwatchId.forEach((item) => {
      console.log(item, "ITEM");
      const swatchValue = item.getAttribute("value");
      if (
        swatchValue.includes(window.renderSwatch_color) &&
        swatchValue.includes("Engrave")
      ) {
        item.click(); // Simulate selection
        variantId = item.dataset.variantId; // ✅ Correct way to get actual ID
      }
    });

    if (!variantId) {
      document.querySelector(".errorOutOfStock").classList.remove("hidden");
      return;
    }

    const properties = {
      Engraving: personalisedText.slice(0, 12).replace(/[^A-Za-z0-9 ]/g, ""),
    };

    fetch("/cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify({
        id: variantId,
        quantity: 1,
        properties: properties,
      }),
    })
      .then((response) => {
        if (!response.ok) {
          return response.text().then((errorText) => {
            throw new Error(errorText);
          });
        }
        return response.json();
      })
      .then((data) => {
        console.log("Added to cart:", data);
        window.location.href = "/cart";
      })
      .catch((err) => {
        console.error("Error adding to cart:", err.message);
        document.querySelector(".errorOutOfStock").classList.remove("hidden");
      });
  });

  skipBtn.addEventListener("click", () => {
    const engraveName = document.querySelector(".personalizedText");
    const engraveColor = document.querySelector(".personalizedVariantName");
    pdpATC.type = "submit";
    popUp("add");

    labelSwatchId.forEach((check) => {
      if (check.hasAttribute("checked")) {
        const hiddenInput = window.renderSwatch_color.replace(" - Engrave", "");
        const fallbackRadio = document.querySelector(
          `.product-form__input.Color input[value="${hiddenInput}"]`
        );
        if (fallbackRadio) fallbackRadio.click();
      }
    });

    if (engraveName) engraveName.remove();
    if (engraveColor) engraveColor.remove();

    const form = document.querySelector(".main-product-price-content form");
    if (form) form.submit();

    const errorMsg = document.querySelector(".errorOutOfStock");
    if (errorMsg) errorMsg.classList.add("hidden");
  });

  // document.querySelector('.t_c_engraving').addEventListener('click', () => {
  //   document.querySelector('.t_c_engraving span').classList.toggle('revolute');
  //   document.querySelector('.engravingDescription').classList.toggle('hidden');
  // });

  // Word counter for engraving input
  const inputEngraving = document.querySelector(
    ".input_engraving .nameInput_engraving"
  );
  const counterEngraving = document.getElementById("wordCounter");

  function updateLetterCount() {
    const valueLength = inputEngraving.value.length;
    counterEngraving.textContent = `${valueLength}/12`;
  }
  inputEngraving.addEventListener("input", () => {
    console.log("test");
  });
  if (inputEngraving && counterEngraving) {
    inputEngraving.addEventListener("input", updateLetterCount);
    updateLetterCount();
  }
});
